var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-21.333,-21.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.333,21.333C24.041,21.333 21.333,24.041 21.333,27.333C21.333,30.625 24.041,33.333 27.333,33.333C30.625,33.333 33.333,30.625 33.333,27.333C33.333,24.041 30.625,21.333 27.333,21.333ZM27.333,32.242C24.64,32.242 22.424,30.026 22.424,27.333C22.424,24.64 24.64,22.424 27.333,22.424C30.026,22.424 32.242,24.64 32.242,27.333C32.242,30.026 30.026,32.242 27.333,32.242Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-13.209,-5.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.088,32.391L41.088,29.344C41.088,29.045 40.842,28.799 40.543,28.799C40.243,28.799 39.997,29.045 39.997,29.344L39.997,32.617C39.997,32.761 40.055,32.9 40.157,33.002L41.793,34.638C41.895,34.74 42.034,34.798 42.178,34.798C42.478,34.798 42.724,34.552 42.724,34.252C42.724,34.108 42.666,33.969 42.564,33.867L41.088,32.391Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.474f5b8e.svg";
export { ForwardRef as ReactComponent };